<script setup lang="ts">
import { load } from "cheerio";

interface Props {
  text: string;
}

const props = defineProps<Props>();

// TODO: use classes from config
function addTailwindClasses(html: string): string {
  const $ = load(html);

  // $("h1").addClass("text-3xl md:text-4xl font-bold mb-6 text-gray-800");
  // $("h2").addClass("text-2xl md:text-3xl font-semibold mb-5 text-gray-800");
  // $("h3").addClass("text-xl md:text-2xl font-medium mb-4 text-gray-800");
  // $("h4").addClass("text-lg md:text-xl font-medium mb-3 text-gray-800");
  // $("h5").addClass("text-base md:text-lg font-medium mb-2 text-gray-800");
  // $("h6").addClass("text-sm md:text-base font-medium mb-1 text-gray-800");

  // $("p, span, figcaption").addClass(
  //   "text-gray-500 text-sm md:text-base mb-6 leading-relaxed"
  // );

  $("ul").addClass("list-disc list-outside ml-10 mt-2 space-y-1.5");
  $("ol").addClass("list-decimal list-outside ml-10 mt-2 space-y-1.5");
  // $("li").addClass("text-gray-500 text-sm md:text-base mb-2");

  // $("img").addClass("w-full h-full rounded-lg shadow-sm");

  // $("blockquote").addClass(
  //   "border-l-2 border-primary pl-4 italic text-gray-800 text-lg md:text-2xl font-semibold my-8 md:my-12"
  // );
  // $("blockquote footer, footer").addClass(
  //   "text-xs md:text-sm text-primary mt-4 md:mt-8 not-italic"
  // );

  $("pre").addClass("overflow-x-auto");
  $("code").addClass("");

  // $("hr").addClass("my-6 md:my-8 border-[var(--p-surface-300)]");

  // $("a").addClass(
  //   "text-primary underline hover:text-primary-700 text-sm md:text-base"
  // );

  // $("u").addClass("underline");
  return $.html();
}

// Prevent XSS manually using a simple regex-based approach (server-safe)
function sanitizeHtml(html: string): string {
  return html
    .replace(/<script.*?>.*?<\/script>/gi, "") // Remove scripts
    .replace(/javascript:/gi, ""); // Remove JS execution in links
}

// Check if input is rich text
const isRichText = /<[^>]+>/i.test(props.text);
const processedText = isRichText
  ? sanitizeHtml(addTailwindClasses(props.text))
  : props.text;
</script>

<template>
  <div class="prose prose-lg mx-auto" v-html="processedText"></div>
</template>
